import { render, staticRenderFns } from "./IcySilverSwitch.vue?vue&type=template&id=3d754b40&scoped=true"
import script from "./IcySilverSwitch.vue?vue&type=script&lang=ts"
export * from "./IcySilverSwitch.vue?vue&type=script&lang=ts"
import style0 from "./IcySilverSwitch.vue?vue&type=style&index=0&id=3d754b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d754b40",
  null
  
)

export default component.exports